'use client';
import { css } from 'styled-system/css';

export const menuIconStyle = {
	menuIcon: css({
		position: 'relative',
		flex: 'none',
	}),
	menuLiveIcon: css({
		display: 'flex',
		position: 'absolute',
		bottom: 0,
		right: 0,
		width: '12px',
		height: '12px',
		bgColor: 'var(--s800)',
		rounded: '6px',
		'& .icon': {
			width: '12px',
			height: '12px',
			color: 'status.negative',
		}
	}),
	rightIcon: css({
		color: 'black.3',
		'.tag + &': {
			ml: 0,
		}
	}),
	tip: css({
		color: 'blackOpacity.87',
		bgColor: '#FFF5C2',
	}),
};